var locationObj = {};
$(document).ready(function() {
    //var savedValue = localStorage.getItem('suburb');
    locationObj = JSON.parse(localStorage.getItem('locationData'));
    if (locationObj) {
        $("body").addClass("suburb_found");
        $('#postcode1').val(locationObj.suburb.replace(/\+/, " ")+', '+locationObj.state+', '+locationObj.postcode);
        $('#deliverytrigger1').trigger('click');
        $('.change_button').find("button").addClass("active");
        $('.change_button').find("button").removeAttr("disabled");
        $('#cust-latitude').val(locationObj.latitude);
        $('#cust-longitude').val(locationObj.longitude);
    } else {
        $('#postcode1').val('');
        $("body").removeClass("suburb_found");
        $('.change_button').find("button").removeClass("active");
        $('.change_button').find("button").attr("disabled", "true");
    }
});

// DROPDOWN See the format in cart page LSF
$('.dropdown-menu label').on('click', function(){
   $(this).parents('.dropdown').removeClass('open');
   var value = $(this).find('input').val();
   $('.dropdown-menu label').not(this).parents('li').removeClass('active');
   $('.dropdown-toggle .plc').text(value).addClass('bld');
});

$('.mobile-trigger-back').on('click', function(){
   $('.mobile-nav-bar').removeClass('menu-active')
   $('.mobile-nav-wrapper li').removeClass('mobile-active')
})
$('.mobile-nav-icon.trigger.all').on('click', function(){
   $('.mobile-nav-bar').removeClass('menu-active');
   $('.mobile-nav-wrapper li').removeClass('mobile-active');
})
$(document).ready(function() {
   //Floating menu (spy scroll)
   $(function() {
       var header = $(".megamenu-background");
       $(window).scroll(function() {
           var scroll = $(window).scrollTop();
           var distace  = 364;
           if (scroll >= distace) {
               header.addClass("fixed");
               if (scroll >= distace+40 ) {
                 header.addClass("show");
               } else {
                 header.removeClass("show");
               }
           } else {
               header.removeClass("fixed");
           }
       });
   });
});

$('.close-mega-sub-menu').click(function(){
 $('.with-sub-menu').removeClass('active');
 $(this).hide();
});

$('.with-sub-menu > a').click(function() {
 // Hide Collection on page menu
 //$(this).parents('.with-sub-menu').addClass('active');
 $('.type-menu-collection').removeClass('show-menu');
 setTimeout(function() {
   $('.close-mega-sub-menu').show();
 }, 500);
});

// ACTIVATE SMOOTH SCROLL FOR CHILD OF MAIN MENU THAT IS CURRENT
$("ul.megamenu > li.click li.activated li a").click(function(y) {
 var parent = $(this).parents('.with-sub-menu');
 parent.addClass('hide-submenu');
 $('.close-mega-sub-menu').hide();
 $('.type-menu-collection').addClass('show-menu');
 // Reactive main menu
 setTimeout(function() {
   parent.removeClass('active');
   parent.removeClass('hide-submenu');
 }, 500);
 // Smooth scroll is here
 var getId = $(this).attr("href").split('#');
 if(getId[1]){
    var C = '#'+getId[1];
    $("html,body").animate({
        scrollTop: $(C).offset().top - 100
    }, 800, "swing");
 }
});

// ACTIVATE URL FOR CHILD OF MAIN MENU THAT IS NOT CURRENT
$("ul.megamenu > li.click li.notactive a, ul.megamenu > li.click li.activated > a, a.mi-subimage--wrapper").click(function(y) {
 window.location = $(this).attr("href");
});

// SMOOTH SCROLL ALL URL WITH HASH #
if(window.location.hash) {
 var hash = window.location.hash;
 $('html, body').animate({
   scrollTop: $(hash).offset().top - 50
 }, 2000, 'swing');
}

// CLOSE BUTTON FOR MAIN MENU
$('body').click(function(evt){    
    if(evt.target.className == "sub-menu")
    return;
    
    //For descendants of menu_content being clicked, remove this check if you do not want 
    // to put constraint on descendants.
    if($(evt.target).closest('.sub-menu').length)
    return;             

    //Do processing of click event here for every element except with id menu_content
    $('.close-mega-sub-menu').hide();
});


$(document).ready(function() {
   // SHOW LOCATION FORM SIDEBAR
   $('.location-unknown .change_suburb').click(function(ev){
       ev.preventDefault();
       $('body').addClass('location-set-active');
       $(".moreless-button.custom_act").trigger('click');
   })
   $('.sidebar.get-suburb .icon-close a, .get-suburb-mask').click(function(ev){
       ev.preventDefault();
       $('body').removeClass('location-set-active');
   })




   // SHOW FILTER COLLECTION
   $(".show-collection-filter").click(function(ev){
       ev.preventDefault();
       $("#sidebar-shadow").toggleClass('width-0');
       $("#sidebar").toggleClass('left-0');
       $("#col-main").toggleClass('width-100');
       $('.product-grid .col-xs-6').toggleClass('col-sm-3');
       $('.product-grid .col-xs-6').toggleClass('col-sm-4');
       $('.show-collection-filter').find('span').toggleClass('active');
       if($(document).innerWidth() < 767){
         $('.advanced-filter:not(.remove-filter)').hide();
         $('body').toggleClass('overflow-hidden');
       }
   })

   // ACTIVE COLLECTION ON PAGE MENU when scroll
   $(function() {
     var sections = $('section');
     var navigation_links = $('nav a');
     sections.waypoint({
     handler: function(direction) {
       var active_section;
       active_section = $(this);
       if (direction === "up") active_section = active_section.prev();
       var active_link = $('nav a[href="#' + active_section.attr("id") + '"]');
       navigation_links.parent().removeClass("active");
       active_link.parent().addClass("active");
       //active_section.addClass("active-section");
     },
     offset: '35%'
     });
   });


});

$('#playyoutube').on('click', function(ev) {
   $("#youtube-video")[0].src += "&autoplay=1";
   $('.tp-parallax-wrap').fadeOut(600, "linear", function() {
       $('.youtube-still').addClass("playing");
   });
   ev.preventDefault();
});

$('.playyoutube').on('click', function(ev) {
   ev.preventDefault();
   $(this).parents('.youtube-icon-trggr').toggleClass("playing")
   var youtubeVideo = $(this).attr("data-video");
   var caption = ".youtube-caption-"+youtubeVideo
   if ($(this).hasClass("ply")) {
       $(this).removeClass("ply");
       //pause
       $("#"+youtubeVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
       $("#"+youtubeVideo).fadeOut(500, "linear", function(){
           $(caption).fadeIn(500, "linear", function(){});
           //stop
           $("#"+youtubeVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
       });
   } else {
       $(this).addClass("ply");
       $("#"+youtubeVideo)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
       $(caption).fadeOut(500, "swing", function(){
           $("#"+youtubeVideo).fadeIn(500, "swing", function(){});
       });
   }
});

$('.slide-body').on("mouseenter", ".youtube-icon-trggr.playing", function() {
   $(this).find('a').show()
});
$('.slide-body').on("mouseleave", ".youtube-icon-trggr.playing", function() {
   $(this).find('a').hide()
});



// TRAMPOLINE SPRINGLESS and SPRING FILTER PAGE
$('.content-accordion h3').click(function() {
 $(this).siblings('ul').slideToggle('fast');
 $(this).find('i').toggleClass('aDown');
 $('.select-size-container').toggleClass('adjust');
 return false;
});

$( "#listTrampolines li" ).click(function() {
 var size =  '.'+$(this).attr("data-value");
 var sizeText = $(this).html();
 $('.springsizes.clearfix .fifth').hide();
 $(size).show();
 $("#sizeText").html(sizeText);
 $('.dropdown').removeClass('open');
 $('.select-size-container').removeClass('adjust');
});

// FOR PARALLAX SO THAT IT WILL NOT BREAK WHEN RESIZE AND LOAD
var timer;
$(window).bind('resize', function() {
clearTimeout(timer);
timer = setTimeout(function(){ $(window).resize(); }, 250);
});
var timer;
$(window).bind('load', function() {
clearTimeout(timer);
timer = setTimeout(function(){ $(window).load(); }, 250);
});


$('.custom-show_paylater').click(function(ev){
   ev.preventDefault();
   $('.payment-methods').slideToggle();
})

// Postage calculator #01 (typing...)
$('input#postcode1').val();
$(document).ready(function() {
 $('input#postcode1').keyup(function(e){  
   var txtInput = $(this).val();
   if (txtInput.length > 2){
     $('#suburb').css('height', 'auto');
     $('#suburb').slideDown();
     $('#suburb').addClass('active');
     // $('.change_button').find("button").addClass("active");
     // $('.change_button').find("button").removeAttr("disabled");
     $('#suburb ul').html('');
     $('#suburb  .spinner').show();
     // $('.get-suburb .spinner-1').show();
     e.preventDefault();
     $.ajax({
       url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=713&deploy=1&compid=1117015&ns-at=AAEJ7tMQEHiNlvu41bPcPH-Klcl0BC-WPko6HsiOAER-WqJ5IqE&q="+txtInput,
       type: "get",
       crosscallDomain: true,
       dataType: "jsonp"
     })
     .done(function (data) {
       $('#suburb ul').html('');
       if (data.localities == "") {
         $('#suburb .spinner').hide();
         $('#suburb ul').append('<li><strong>Not Found</strong></li>')
       } else {
         displaySuburb(data.localities.locality);
       }
     })
     .fail(function(jqXHR, textStatus, errorThrown) {
       console.log(textStatus + '; ' + errorThrown);
     })
   } else {
     $('#suburb').removeClass('active');
     // $('.change_button').find("button").removeClass("active");
     // $('.change_button').find("button").attr("disabled");
     // $('.get-suburb .spinner-1').hide();
   }
   
 });
});

function isObject (value) {
 return value && typeof value === 'object' && value.constructor === Object;
}

// Postage calculator #02 (display suburb)
function displaySuburb(data) {
    $('#suburb .spinner').show();
    if(isObject(data)){
        data = [data]
    }
    $('#suburb ul').html('');
    // create attribute
    $('#suburb .spinner').hide();
    for (var i = 0; i < data.length; i++) {
        var attr = 'postcode="'+data[i].postcode+'" latitude="'+data[i].latitude+'" longitude="'+data[i].longitude+'" state="'+data[i].state+'"';
        $('#suburb ul').append('<li '+attr+'><strong>' + data[i].location + '</strong>, ' + data[i].state + ', ' + data[i].postcode + '</li>')
    }
}

// Postage calculator #03 (get suburb)
$("#suburb ul").on('click', 'li', function(ev) {
    console.log(locationObj);
    $('#suburb').slideUp();
    $('#postcode1').val($(this).text());
    $('.change_button').find("button").addClass("active");
    $('.change_button').find("button").removeAttr("disabled");

    var selectedLoc = $(this).text().split(',');
    var selectedSuburb = selectedLoc[0].replace(/ /gi, "+");

    $('#productId').attr('data-postcode', $(this).attr('postcode'));
    $('#productId').attr('data-suburb', selectedSuburb);

    //New format storing location data
    locationObj = {
        suburb: selectedSuburb,
        postcode: $(this).attr('postcode'),
        latitude: $(this).attr('latitude'),
        longitude: $(this).attr('longitude'),
        state: $(this).attr('state')
    }
    $('#cust-longitude').val(locationObj.longitude);
    $('#cust-latitude').val(locationObj.latitude);
    if($('#showroom-trigger').hasClass('showroom-loaded')){ 
        $('#cust-latitude').trigger('change'); // If showroom already loaded update it.
    }

    $('#productId script').text(JSON.stringify(locationObj))
    localStorage.setItem("locationData", JSON.stringify(locationObj));
    $('#deliverytrigger1').trigger('click');
});


// Postage calculator #04 (click go)
$('#deliverytrigger1').click(function() {
    if (locationObj) {
        if ($('.this-is-cart-page').length != 0) {
            var sku = $('#allsku').attr('data-sku');
        } else {
            var sku = $('.sku').text();
        }
        postageCalc(sku);
    }
});

// Postage calculator #05 (ajax call...)
function postageCalc(sku){
    if(!locationObj){
        return false;
    }
    var postcode = locationObj.postcode;
    var suburb = locationObj.suburb;
    console.log(locationObj);
    var url = 'https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=712&deploy=1&compid=1117015&ns-at=AAEJ7tMQmWDVLsk37sTXyeC7k2gKi91BwzdlLcYf8Y9arlMnQew&postcode='+postcode+'&suburb='+suburb+'&item_sku='+sku+'&source=lifespan-kids';
    $.ajax({
        url: url,
        type: "get",
        crosscallDomain: true,
        dataType: "jsonp",
        beforeSend: function(xhr) {
            $('.spinner-1').show();
        }
    }).done(function(data) {
        // console.log("data",data);
        if (data.error.length >= 1) {
           $('.delivery-check-result').hide();
           $('.location-unknown').find(".location_information").show();
           $('.location-unknown').find(".location_set_info").hide();
           // var getInputValue = $('#postcode1').val();
           $('.check-result-container #noprice').remove();
           $('.check-result-container').append('<p id="noprice" style="font-size:13px;">This area requires a custom freight quotation. Please contact us via 1300 169 600 during business hours for assistance. </p>');
           $('.delivery-pickup .spinner-1').hide();
            $('.check-result-container').slideDown('slow');
           $(".moreless-button").show();
           console.log(data.error);
        } else {
            updatePrice(data.uniq_rates);
            var get_state = data.shipping_state;
            function getState() {
                getQuantityData(function(dataQuantity) {
                    if (dataQuantity.length === 1) {
                      var d = dataQuantity[0].inventory;
                      var locationDivs = ''; // String to hold all location divs
                
                      for (var l = 0; l < d.length; l++) {
                        var locationId = '.location-' + d[l].inventory_location_id;
                        var getQuantity = d[l].location_quantity_available;
                        var getStateName = d[l].inventory_location_name;
                        var words = getStateName.split(/\s+/);
                        
                        // Get the last word
                        var lastWord = words.slice(-1).join(' ');
                        locationDivs += `<div class="location_quantity hidden" data-location-name="${lastWord}" data-location-quantity="${getQuantity}"></div>`;
                      }
                
                      // Append all location divs at once
                      $(".location_wise_inventory").html(locationDivs);
                      
                      /**
                      // Flag to check if a matching location was found
                      var foundMatch = false;
                
                      // Now handle showing/hiding collection point and tab
                      $(".location_wise_inventory").find(".location_quantity").each(function() {
                        var getLocationName = $(this).attr("data-location-name");
                        //console.log("get_state", get_state);
                
                        if (get_state === getLocationName) {
                          foundMatch = true; // A match is found
                          var getLocationQuantity = $(this).attr("data-location-quantity");
                          if (getLocationQuantity < 1) {
                            $('.collection_point').show();
                            $('#tab3').show();
                          } else {
                            $('.collection_point').hide().removeClass("active");
                            $('#tab3').hide().removeClass('active in');
                            $(".nav-tabs li").eq(0).addClass("active");
                            $(".tab-pane").eq(0).addClass("active in");
                          }
                        }
                      });
                
                      // If no match was found, ensure the collection point is hidden
                      if (!foundMatch) {
                        $('.collection_point').hide().removeClass("active");
                        $('#tab3').hide().removeClass('active in');
                        $(".nav-tabs li").eq(0).addClass("active");
                        $(".tab-pane").eq(0).addClass("active in");
                      }
                      **/
                    }
                });
            }
            getState();
        }
    }).fail(function() {
        $('#postage-results').html('Unkown errors, please try again later!');
    });
}

function updatePrice(e) {
    // var getInputValue = $("#postcode1").val()//$('#productId script').text();
    // localStorage.setItem('suburb', getInputValue);
  
 
 $('.location_set_info').find(".info strong").text(locationObj.suburb.replace(/\+/, ' ')+', '+locationObj.state+' '+locationObj.postcode);
 void 0 === e == 0 ? (jQuery(window).trigger("resize").trigger("scroll"), $(".premium_diverse-container").hide(), $('.location-unknown').find(".location_set_info").show(), $('.location-unknown').find(".location_information").hide(), $(".delivery-check-result").show(), $(".delivery-check-result .rate").html("Not Available"), $(".delivery-check-result #regular").html("Please contact us for a quote"), $(".default-hide.cart-page").hide(), $("#noprice").hide(), $.getJSON("https://lifespanonline.com.au/postage-query/info/delivery-information.json", (function(t) {
   $(".delivery-info").each((function(e) {
     var i = $(this).attr("data-deliveryinfo");
     t[i] && ($(".delivery-info." + i + " ul").html(t[i].includes.join("")), "" != t[i].additional_info && $(".delivery-info." + i + " ul").append(t[i].additional_info))
   }));
   for (var i = 0; i < e.length; i++) {
     var a = e[i].type.replace(/\|/g, "_");
     if ($(".cart-page." + a).show(), 0 == e[i].total_price) $(".delivery-check-result #" + a).html(t[a].if_zero);
     else {
       var n = e[i].total_price.toFixed(2);
       $(".delivery-check-result #" + a).html("$" + n)
     }
      if ("pickup" == e[i].type) {
       var get_state = e[i].display_code
         console.log("get_state",get_state);
        $(".pickup").find(".click_collect").text(get_state);
       }

     if ("premium|diverse" == e[i].type && $(".premium_diverse-container").show(), "pickup" == e[i].type) {
       var s = e[i].display_code.split("@"); 
       
       $("#pickupLoc").html(s[1]), "Pickup NSW" == e[i].carrier_name || "Pickup VIC" == e[i].carrier_name ? $(".pickup-container").hide() : $(".pickup-container").show()
     }
   }
 }))) : ($('.location-unknown').find(".location_set_info").hide(), $('.location-unknown').find(".location_information").show(), $(".delivery-check-result").hide(), $(".check-result-container").append('<p id="noprice" style="font-size:13px;">Please contact us via online chat or phone for a tailored shipping quote. </p>')), $(".delivery-pickup .spinner-1").hide(), $('.get-suburb .spinner-1').hide(), $(".clearfix").find(".pull-right").trigger('click'), $(".check-result-container").slideDown("slow"), $(".moreless-button").show();  
   if ($("body").hasClass("suburb_found")) {
     $('.get-suburb .spinner-1').hide();
     // $(".moreless-button span").text("Show More");
     // $(".moreless-button").addClass("active");
     $('.change_button button').trigger('click');
     
   }else{
     // $(".check-result-container").slideDown("slow");
   } 
 
}


// CHECK IF THIS IS CART PAGE
if ($('.this-is-cart-page').length != 0 ) {
   // QTY COUNTER
   $(".q_up").unbind("click"), $(".q_up").on("click", function() {
       var C = $(this).data("product_id"),
           S = parseInt($(".quantity-cart-" + C).val()) + 1;
       $(".quantity-cart-" + C).val(S);

   }), $(".q_down").unbind("click"), $(".q_down").on("click", function() {
       var C = $(this).data("product_id"),
           S = parseInt($(".quantity-cart-" + C).val());
       1 < S && $(".quantity-cart-" + C).val(S - 1)
 })
}

$('#availability-trigger').on('click', function(e) {
 pickUpLocation();
});

// Stock Availability in each store #02 (Quantity)
function getQuantityData(logResults){
 var isMulti = $('.sku').attr('data-multisku');
 var url;
 if (isMulti == 'false') {
   var sku = $('.sku').text();
 } else {
   var sku = $('.sku').attr('data-skus');
 }
 var data;
 $.ajax({
   url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=623&deploy=1&compid=1117015&ns-at=AAEJ7tMQkyX-9quosAYuoRdLWndgI5fkODhy5BL-FR50CUontp0&item_key_type=sku&item_keys="+sku+"&location=15,10,9&jsonp=y",
   type: "get",
   crosscallDomain: true,
   dataType: "jsonp",
   jsonpCallback: "logResults",
   success: function (resp) {
     //console.log("resp",resp);
     data = resp;
     // console.log(data.inventory)
     logResults(data.inventory);
   },
   error: function () {}
 });
}


// Stock Availability in each store #03 (Display)
function pickUpLocation(){
 var i;
 getQuantityData(function(dataQuantity) {
   if (dataQuantity.length == 1) {
     var d = dataQuantity[0].inventory;
     for (var l = 0; l < d.length; l++) {
       var locationId = '.location-'+d[l].inventory_location_id;
       if (d[l].location_quantity_available < 10 ) {
         if (d[l].location_quantity_available < 1 ) {
           $("#dynamicPickUpResult "+locationId).addClass('out-stock');
           $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>Out of Stock');
         } else {
           $("#dynamicPickUpResult "+locationId).addClass('low-stock');
           $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>Limited Stock');
         }
       }else{
         $("#dynamicPickUpResult "+locationId).addClass('in-stock');
         $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>In Stock');
       }
     }
   }

   if (dataQuantity.length > 1) {
     for (var k = 0; k < dataQuantity.length; k++) {
       var sku = dataQuantity[k].sku.replace('.', '-');
       for (var m =  0; m < dataQuantity[k].inventory.length; m++) {
         // Minimise loading time we only process the exact location id
         var locId = dataQuantity[k].inventory[m].inventory_location_id;
         if (locId == '15' || locId == '10' || locId == '9') {
           var invQuant = dataQuantity[k].inventory[m].location_quantity_available;
           var locationId = '.location-'+locId+'.'+sku;
           if (invQuant < 10 ) {
             if (invQuant < 1 ) {
               $("#dynamicPickUpResult "+locationId).addClass('notavailable');
               $("#dynamicPickUpResult "+locationId).text('Out of Stock');
             } else {
               $("#dynamicPickUpResult "+locationId).text('Limited Stock');
               $("#dynamicPickUpResult "+locationId).addClass('limited-stock');
             }
           }else{
             $("#dynamicPickUpResult "+locationId).addClass('available');
             $("#dynamicPickUpResult "+locationId).text('In Stock');
           }
           // if (invQuant == 5) {
           //   console.log(locationId+' ===== '+invQuant);
           //   $("#dynamicPickUpResult "+locationId).text('notavailable');
           // }
         }
       }
     }
   }
 });
}


// WHEN POSTCODE OR SKU is incorrect
function showError(data){
 jQuery(window).trigger('resize').trigger('scroll');
 $('.delivery-pickup .spinner-1').hide();
 // $('.check-result-container').slideDown('slow');
 // $(".moreless-button").show();
 $(".clearfix").find(".pull-right").trigger('click');
 var i;
 for (i = data.length - 1; i >= 0; i--) {
   $('.delivery-check-result').html("<p style='color: #F8ACAC'>"+data[i]+"</p>");
 }
}

// PRODUCTS PAGE
$('.trigger-delivery-info').click(function(){
 $(this).toggleClass('active');
 var target = $(this).attr('data-target');

 $('.delivery-info.'+target).toggleClass('hide');
 $('.delivery-info:not(.'+target+')').addClass('hide');
 $('.trigger-delivery-info').not(this).removeClass('active');
});


// COLLECTION WHEN TYPE-MENU CLICKED
$('.type-menu-collection li').click(function(){
 $('.type-menu-collection li').removeClass('active');
 $(this).addClass('active');
 $('.collection-nav-mob').removeClass('open');
});

$(function() {
   var header = $(".type-menu-collection");
   $(window).scroll(function() {
       var scroll = $(window).scrollTop();
       var distace  = 420;
       if (scroll >= distace) {
           header.addClass("fixed");
           if (scroll >= distace+40 ) {
             header.addClass("show-menu");
           } else {
             header.removeClass("show-menu");
           }
       } else {
           header.removeClass("fixed");
       }
   });
}); 


// PAGES
$('body').on('click', '.collapse-trigger', function(e) {
 e.preventDefault();
 if ($(this).hasClass('with-icon')) {
   $(this).find('i').toggleClass('aDown');
 }
 $(this).parents('.collapse-container').toggleClass('reveal');
 $(this).siblings('.collapse-hide').slideToggle('slow');
});


$('.file-input-modified input').each(function(){
 var $input   = $(this);
 var $label   = $input.next('label');
 var labelVal = $label.html();

 $('.file-input-modified').on('change', 'input', function(e){
   var fileName = '';
   if(e.target.value)
     fileName = e.target.value.split( '\\' ).pop();
   if(fileName)
     $(this).siblings('label').find('.fn').html(fileName);
   else
     $label.html(labelVal);
 });

 // Firefox bug fix
 $input
 .on('focus', function(){ $input.addClass('has-focus');})
 .on('blur', function(){ $input.removeClass('has-focus'); });
});

// Javascript to enable link to tab
var url = document.location.toString();
if (url.match('#')) {
 var target = '#'+url.split('#')[1];
 const tabDestination = $('.nav-tabs a[href="' + target + '"]');
 if ($(target+'.tab-pane').length  > 0) {
   const tabDestination = $('.nav-tabs a[href="' + target + '"]');
 } else {
   // content inside tab
   target = '#'+$(target).attr('data-parenttab');
   const tabDestination = $('.nav-tabs a[href="' + target + '"]');
 }
 tabDestination.tab('show');
 tabDestination.addClass('disabled');
 $('#nav-tabContent .tab-pane.active:not('+target+')').addClass('force-hide');
 $('#nav-tabContent '+target).addClass('force-show');
} 
$('.nav-tabs a').on('click', function() {
 if ($(this).hasClass('disabled')) {
   return;
 } else {
   $('#nav-tabContent .tab-pane').removeClass('force-hide force-show');
   $('.nav-tabs a').removeClass('disabled');
 }
});

function boMssgChange(el){
   // HOW To >> 1. input linebackorder as previous sibling, 2. add class product id to class variant-inv
   var selectedVariant = '.'+$(el).find('option:selected').text()+'_'+el.value;
   // Back order message
   $('.'+el.attributes.id.value+' li').addClass('hide');
   $('.'+el.attributes.id.value+' li'+selectedVariant).removeClass('hide');

   //line properties
   var lineValue = $('.variant-inv li'+selectedVariant).text();
   el.previousElementSibling.value = lineValue;
}
$(".mega-stores li a").click(function(){
   event.preventDefault(); 
   var store = $(this).attr('data-target');
   if (store != 'false') {
       $(store).click(); 
       var C = '#map-canvas';
       $("html,body").animate({
           scrollTop: $(C).offset().top - 100
       }, 800, "swing");
   }
});

$('body').on('click', '.store-list li', function(e) {
   var C = '#map-canvas';
   $("html,body").animate({
       scrollTop: $(C).offset().top - 100
   }, 800, "swing");

});

$(document).ready(function() {
    let currentIndex = 0;
    const slides = $('.slides li');
    const dots = $('.dot');
    let getSpeed = $(".home-slider-content").attr("data-slider_interval");
    const slideCount = slides.length;

    function goToSlide(index) {
        slides.removeClass('active').eq(index).addClass('active');
        dots.removeClass('active').eq(index).addClass('active');
        currentIndex = index;
    }
    // Initialize
    goToSlide(currentIndex);
  
    // Automatic sliding (optional)
  
    setInterval(function() {
        const nextIndex = (currentIndex + 1) % slideCount;
        goToSlide(nextIndex);
    }, getSpeed); // Change slide every 3 seconds

if ($("body").hasClass("templateProduct")) {
if (window.innerWidth < 768) {
  // console.log("mobile");
  const customEntry = document.querySelector(".custom-entry");
  const productFocusContainer = customEntry.querySelector(".product-focus-container");
  if (productFocusContainer) {
      console.log("productFocusContainer", productFocusContainer);
      productFocusContainer.remove(); // Directly remove the element
  }
} else {
  // console.log("desktop");
  const productImagesWrapper = document.querySelector(".product-images-wrapper");
  const mobileTitle = productImagesWrapper.querySelector(".mobile-title");
  if (mobileTitle) {
      mobileTitle.remove(); // Directly remove the element
  }
}
}

});

